import BaseListagem from "components/BaseListagem";
import ContaParametro from "model/administracao/cadastro/ContaParametro";
import { Column } from "primereact/column";
import ContaParametroService from "service/administracao/cadastro/ContaParametroService";
import { converterHorario } from "utils/convert";

const contaParametroService : ContaParametroService = new ContaParametroService();

export default function ContaParametroListagem(){

    return (

        <BaseListagem ordenacao="parametro.sigla,ASC" service={contaParametroService} urlService="/parametro" tituloPagina={'Parâmetros'} >
            <Column field="parametro.sigla" header="Sigla" />
            <Column field="parametro.nome" header="Nome" />
            <Column header="Valor" body={(rowData: ContaParametro) => {
                if(rowData.parametro.tipo === 'TEXTO'){
                    return rowData.valorTexto;
                }
                if(rowData.parametro.tipo === "NUMERICO"){
                    return rowData.valorNumerico;
                }
                if(rowData.parametro.tipo === "INTEIRO"){
                    return rowData.valorInteiro;
                }
                if(rowData.parametro.tipo === "BOOLEANO"){
                    return rowData.valorBooleano ? 'Sim' : 'Não';
                }
                if(rowData.parametro.tipo === "HORARIO"){
                    return converterHorario(rowData.valorHorario||0);
                }
            }} />
        </BaseListagem>
    )
}